/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roman Numeral Converter — Number ↔ Roman | Toolverse`)
};

const es_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de Numerales Romanos — Número ↔ Romano | Toolverse`)
};

const de_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umrechner für römische Zahlen — Zahl ↔ Römisch | Toolverse`)
};

const nl_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter voor Romeinse Getallen — Getal ↔ Romeins | Toolverse`)
};

const fr_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de Chiffres Romains — Nombre ↔ Romain | Toolverse`)
};

const it_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di Numerali Romani — Numero ↔ Romano | Toolverse`)
};

const pt_br2_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Numerais Romanos — Número ↔ Romano | Toolverse`)
};

const pt_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Numerais Romanos — Número ↔ Romano | Toolverse`)
};

const ja_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローマ数字コンバーター — 数字 ↔ ローマ数字 | Toolverse`)
};

const zh_rn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`罗马数字转换器 — 数字 ↔ 罗马数字 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_meta_title", locale)
	if (locale === "en") return en_rn_meta_title(inputs)
	if (locale === "es") return es_rn_meta_title(inputs)
	if (locale === "de") return de_rn_meta_title(inputs)
	if (locale === "nl") return nl_rn_meta_title(inputs)
	if (locale === "fr") return fr_rn_meta_title(inputs)
	if (locale === "it") return it_rn_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_rn_meta_title(inputs)
	if (locale === "pt") return pt_rn_meta_title(inputs)
	if (locale === "ja") return ja_rn_meta_title(inputs)
	return zh_rn_meta_title(inputs)
};